import { useContext } from 'react'
import UserContext from '../../UserContext'
import IdentifierWithCopy from './IdentifierWithCopy'

type PopoutHeadingProps = {
    mainTitle: string
    subTitle: string
    identifier?: string | number
}

const PopoutHeading: React.FC<PopoutHeadingProps> = ({ mainTitle, subTitle, identifier }) => {
    const userContext = useContext(UserContext)
    
    return (
        <>
            <div className="header-bar">
                {/*<i className="fas fa-expand-alt" onClick={() => ExpandContractPopout()}></i>*/}
                <img className="logo forPrintOnly" src="/assets/images/heart.svg" alt="Caresource" width="100%" height="100%" />
                <h1 className="forPrintOnly">Provider Sourcing</h1>
                <span className="user-info forPrintOnly"><span className="name forPrintOnly">{userContext.user.name}</span></span>
            </div>

            <h3>{mainTitle} / <span className="emphasis">{subTitle}</span>{IdentifierWithCopy({ identifier })}</h3>
        </>
    )
}

export default PopoutHeading